import { Settings } from "luxon"

import { FALLBACK_LANG } from "$/constants"

import type { IUserModel } from "@/3514/types"
import { Language } from "@/models/state"

import { isNullOrUndefined } from "./gates"

export type TranslationObj = {
    [key in Language]?: string
}

export const getUserLanguage = (user: IUserModel) => {
    const defaultLanguage = user?.languageCode ?? FALLBACK_LANG

    if ("navigator" in window && window !== undefined) {
        const langKey = navigator.language.split("-")[0]
        const languages = !isNullOrUndefined(JSAPP_CONF?.available_languages)
            ? Object.keys(JSAPP_CONF?.available_languages)
            : []
        const language = languages.find(lang => lang === langKey)
        return defaultLanguage !== FALLBACK_LANG && user?.languageCode?.length > 0 ? defaultLanguage : language
    }

    return defaultLanguage
}

export const setLuxonLocale = (userLang: Language) => {
    Settings.defaultLocale = userLang ?? "en-US"
}
